/* ============================================================
   MY RARE AURA — PHASE 5 PREMIUM SEARCH EXPERIENCE JS
   File: assets/aurelle-search.js

   Controls:
   1. Predictive search using Shopify /search/suggest.json
   2. Recent searches saved in localStorage
   3. Keyboard navigation inside predictive results
   4. Search filters mobile toggle
   5. Sort submit
   6. Wishlist persistence on search cards
   7. AJAX quick add
   8. Search Quick View modal
   ============================================================ */

(function () {
  'use strict';

  var RECENT_KEY = 'aurelleRecentSearches';
  var WISHLIST_KEY = 'aurelleWishlist';
  var debounceTimer = null;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[char];
    });
  }

  function readJSON(key, fallback) {
    try {
      return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
    } catch (error) {
      return fallback;
    }
  }

  function writeJSON(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function readRecentSearches() {
    return readJSON(RECENT_KEY, []);
  }

  function saveRecentSearch(query) {
    query = String(query || '').trim();
    if (!query) return;

    var items = readRecentSearches().filter(function (item) {
      return String(item).toLowerCase() !== query.toLowerCase();
    });

    items.unshift(query);
    writeJSON(RECENT_KEY, items.slice(0, 8));
  }

  function readWishlist() {
    return readJSON(WISHLIST_KEY, []);
  }

  function writeWishlist(items) {
    writeJSON(WISHLIST_KEY, items || []);
    document.dispatchEvent(new CustomEvent('aurelle:wishlist-updated', {
      detail: { count: (items || []).length }
    }));
  }

  function getProductImage(product) {
    if (!product) return '';
    if (typeof product.image === 'string') return product.image;
    if (product.image && product.image.url) return product.image.url;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (typeof product.featured_image === 'string') return product.featured_image;
    return '';
  }

  function getProductPrice(product) {
    if (!product) return '';
    if (product.price) return product.price;
    if (product.price_min) return product.price_min;
    return '';
  }

  /* ================= PREDICTIVE SEARCH ================= */

  function renderPopular(panel) {
    var recent = readRecentSearches();
    var popular = ['Wedding Guest', 'Dresses', 'Floral', 'Evening', 'Vacation', 'Brunch'];

    var html = '<div class="aurelle-predictive-panel__grid">';

    html += '<div><p class="aurelle-predictive-panel__heading">Popular Searches</p><div class="aurelle-predictive-list">';
    popular.forEach(function (term) {
      html += '<a class="aurelle-predictive-link" href="/search?q=' + encodeURIComponent(term) + '&type=product">' + escapeHtml(term) + '</a>';
    });
    html += '</div></div>';

    html += '<div><p class="aurelle-predictive-panel__heading">Recent Searches</p><div class="aurelle-predictive-list">';
    if (recent.length) {
      recent.slice(0, 6).forEach(function (term) {
        html += '<a class="aurelle-predictive-link" href="/search?q=' + encodeURIComponent(term) + '&type=product">' + escapeHtml(term) + '</a>';
      });
    } else {
      html += '<div class="aurelle-predictive-empty">Your recent searches will appear here.</div>';
    }
    html += '</div></div></div>';

    panel.innerHTML = html;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
  }

  function renderPredictiveResults(panel, data, query) {
    var results = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = results.products || [];
    var collections = results.collections || [];
    var pages = results.pages || [];
    var articles = results.articles || [];

    if (!products.length && !collections.length && !pages.length && !articles.length) {
      panel.innerHTML = '<div class="aurelle-predictive-empty">No results for “' + escapeHtml(query) + '”. Try dresses, floral, wedding, or evening.</div>';
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      return;
    }

    var html = '<div class="aurelle-predictive-panel__grid">';

    html += '<div>';
    if (products.length) {
      html += '<p class="aurelle-predictive-panel__heading">Products</p><div class="aurelle-predictive-list">';
      products.slice(0, 6).forEach(function (product) {
        var image = getProductImage(product);
        html += '<a class="aurelle-predictive-product" href="' + escapeHtml(product.url) + '">';
        html += image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span></span>';
        html += '<span><strong>' + escapeHtml(product.title) + '</strong><span>' + escapeHtml(getProductPrice(product)) + '</span></span>';
        html += '</a>';
      });
      html += '</div>';
    }
    html += '</div>';

    html += '<div>';
    if (collections.length) {
      html += '<p class="aurelle-predictive-panel__heading">Collections</p><div class="aurelle-predictive-list">';
      collections.slice(0, 4).forEach(function (collection) {
        html += '<a class="aurelle-predictive-link" href="' + escapeHtml(collection.url) + '">' + escapeHtml(collection.title) + '</a>';
      });
      html += '</div>';
    }

    if (pages.length || articles.length) {
      html += '<p class="aurelle-predictive-panel__heading" style="margin-top:18px">Editorial</p><div class="aurelle-predictive-list">';
      pages.slice(0, 3).forEach(function (page) {
        html += '<a class="aurelle-predictive-link" href="' + escapeHtml(page.url) + '">' + escapeHtml(page.title) + '</a>';
      });
      articles.slice(0, 3).forEach(function (article) {
        html += '<a class="aurelle-predictive-link" href="' + escapeHtml(article.url) + '">' + escapeHtml(article.title) + '</a>';
      });
      html += '</div>';
    }
    html += '</div></div>';

    panel.innerHTML = html;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
  }

  function closePredictivePanels() {
    qsa('.aurelle-predictive-panel').forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  function bindPredictiveInput(input) {
    if (!input || input.dataset.aurellePredictiveBound === 'true') return;
    input.dataset.aurellePredictiveBound = 'true';

    var form = input.closest('form');
    var panel = form ? qs('[data-aurelle-predictive-panel], .aurelle-predictive-panel', form) : null;

    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'aurelle-predictive-panel';
      panel.setAttribute('data-aurelle-predictive-panel', '');
      panel.setAttribute('aria-hidden', 'true');
      if (form) {
        form.style.position = form.style.position || 'relative';
        form.appendChild(panel);
      }
    }

    input.addEventListener('focus', function () {
      if (!input.value.trim()) renderPopular(panel);
    });

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (!query) {
        renderPopular(panel);
        return;
      }

      panel.innerHTML = '<div class="aurelle-predictive-empty">Searching My Rare Aura…</div>';
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');

      debounceTimer = window.setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (response) { return response.json(); })
          .then(function (data) { renderPredictiveResults(panel, data, query); })
          .catch(function () { closePredictivePanels(); });
      }, 170);
    });

    input.addEventListener('keydown', function (event) {
      var links = qsa('a', panel);
      if (!panel.classList.contains('is-open') || !links.length) return;

      var active = document.activeElement;
      var index = links.indexOf(active);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        links[index + 1] ? links[index + 1].focus() : links[0].focus();
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        links[index - 1] ? links[index - 1].focus() : input.focus();
      }

      if (event.key === 'Escape') {
        closePredictivePanels();
        input.blur();
      }
    });

    panel.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Escape') return;

      var links = qsa('a', panel);
      var index = links.indexOf(document.activeElement);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        links[index + 1] ? links[index + 1].focus() : links[0].focus();
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        links[index - 1] ? links[index - 1].focus() : input.focus();
      }

      if (event.key === 'Escape') {
        closePredictivePanels();
        input.focus();
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        saveRecentSearch(input.value);
      });
    }
  }

  function initPredictiveSearch() {
    qsa('[data-aurelle-predictive-input], input[type="search"], input[name="q"]').forEach(bindPredictiveInput);

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.aurelle-search-form') && !event.target.closest('.aurelle-predictive-panel')) {
        closePredictivePanels();
      }
    });
  }

  /* ================= SORT / FILTERS ================= */

  function initSortAndFilters() {
    qsa('[data-aurelle-search-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });

    var filterToggle = qs('[data-aurelle-search-filter-toggle]');
    if (filterToggle) {
      filterToggle.addEventListener('click', function () {
        document.body.classList.toggle('aurelle-search-filters-open');
      });
    }

    var filterForm = qs('#AurelleSearchFilters');
    if (filterForm) {
      qsa('input[type="checkbox"]', filterForm).forEach(function (input) {
        input.addEventListener('change', function () {
          filterForm.submit();
        });
      });
    }
  }

  /* ================= WISHLIST ================= */

  function syncWishlistButtons() {
    var wishlist = readWishlist();

    qsa('[data-aurelle-search-wishlist]').forEach(function (button) {
      var active = wishlist.some(function (item) {
        return String(item.id) === String(button.dataset.productId);
      });

      button.classList.toggle('is-wished', active);
      button.textContent = active ? '♥' : '♡';
    });
  }

  function initWishlist() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-aurelle-search-wishlist]');
      if (!button) return;

      var wishlist = readWishlist();
      var id = String(button.dataset.productId || '');
      var exists = wishlist.some(function (item) { return String(item.id) === id; });

      if (exists) {
        wishlist = wishlist.filter(function (item) { return String(item.id) !== id; });
      } else {
        wishlist.unshift({
          id: id,
          variantId: button.dataset.variantId || '',
          title: button.dataset.title || '',
          url: button.dataset.url || '',
          image: button.dataset.image || '',
          price: button.dataset.price || ''
        });
      }

      writeWishlist(wishlist.slice(0, 80));
      syncWishlistButtons();
    });

    document.addEventListener('aurelle:wishlist-updated', syncWishlistButtons);
    syncWishlistButtons();
  }

  /* ================= CART / QUICK ADD ================= */

  function setButtonLoading(button, text) {
    if (!button) return;
    button.dataset.originalText = button.dataset.originalText || button.textContent;
    button.disabled = true;
    button.textContent = text || 'Adding…';
  }

  function resetButton(button, text, delay) {
    if (!button) return;
    window.setTimeout(function () {
      button.disabled = false;
      button.textContent = text || button.dataset.originalText || 'Quick Add';
    }, delay || 1200);
  }

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    });
  }

  function softOpenCartDrawer() {
    var drawer = qs('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (error) {}
    }

    drawer.classList.add('active', 'animate');
    document.body.classList.add('overflow-hidden');
  }

  function initQuickAdd() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-aurelle-search-quickadd]');
      if (!button || button.disabled) return;

      setButtonLoading(button, 'Adding…');

      addVariantToCart(button.dataset.variantId, 1)
        .then(function () {
          button.textContent = 'Added ✓';
          softOpenCartDrawer();
        })
        .catch(function () {
          button.textContent = 'Not Available';
        })
        .finally(function () {
          resetButton(button, button.dataset.originalText || 'Quick Add', 1300);
        });
    });
  }

  /* ================= QUICK VIEW ================= */

  function initQuickView() {
    var modal = qs('#AurelleSearchQuickView');
    if (!modal) return;

    var imageWrap = qs('.aurelle-search-qv__image', modal);
    var title = qs('.aurelle-search-qv__content h2', modal);
    var price = qs('.aurelle-search-qv__price', modal);
    var details = qs('.aurelle-search-qv__details', modal);
    var add = qs('[data-aurelle-search-qv-add]', modal);

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-aurelle-search-quickview]');
      if (!trigger) return;

      if (imageWrap) {
        imageWrap.innerHTML = trigger.dataset.image
          ? '<img src="' + escapeHtml(trigger.dataset.image) + '" width="1000" height="1333" alt="' + escapeHtml(trigger.dataset.title || '') + '" loading="lazy">'
          : '';
      }

      if (title) title.textContent = trigger.dataset.title || '';

      if (price) {
        price.innerHTML = trigger.dataset.compare
          ? '<span>' + escapeHtml(trigger.dataset.price) + '</span><s>' + escapeHtml(trigger.dataset.compare) + '</s>'
          : '<span>' + escapeHtml(trigger.dataset.price) + '</span>';
      }

      if (details) details.href = trigger.dataset.url || '#';

      if (add) {
        add.dataset.variantId = trigger.dataset.variantId || '';
        add.disabled = trigger.dataset.available !== 'true';
        add.textContent = trigger.dataset.available === 'true' ? 'Add to Bag' : 'Sold Out';
      }

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    });

    qsa('[data-aurelle-search-qv-close]', modal).forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    if (add) {
      add.addEventListener('click', function () {
        if (!add.dataset.variantId || add.disabled) return;

        setButtonLoading(add, 'Adding…');

        addVariantToCart(add.dataset.variantId, 1)
          .then(function () {
            add.textContent = 'Added ✓';
            closeModal();
            softOpenCartDrawer();
          })
          .catch(function () {
            add.textContent = 'Not Available';
          })
          .finally(function () {
            resetButton(add, 'Add to Bag', 1300);
          });
      });
    }
  }

  function init() {
    initPredictiveSearch();
    initSortAndFilters();
    initWishlist();
    initQuickAdd();
    initQuickView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
